const Protein = () => {
  return (
    <section className="protein">
      <label for="patty">
        <strong>What type of protein would you like?</strong>
      </label>
      <br />
      <br />
      <input type="text" name="patty" className="patty" />
      <br />
      <br />
    </section>
  );
};

export default Protein;
